import { useMemo } from "react";
import { Provider } from "react-redux";
import ConferenceCallButton from "../ConferenceCallButton";

export default () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);

  return (
    <Provider store={store}>
      <ConferenceCallButton />
    </Provider>
  );
};
